import ArticleDetailEntity from './ArticleDetailEntity.js'
import ArticleEntity from './ArticleEntity.js'
import ArticleImageEntity from './ArticleImageEntity.js'
import AuthorEntity from './AuthorEntity.js'
import TagEntity from './TagEntity.js'

export default class NewsEntitiesFactory {
  static tagEntity = ({id, url, text, rel}) => new TagEntity({id, url, text, rel})

  static articleImageEntity = ({url, cutCoordinates}) => new ArticleImageEntity({url, cutCoordinates})

  static articleEntity = ({
    articleId,
    config,
    id,
    img,
    tag,
    numComments,
    commentsDisabled,
    description,
    url,
    title,
    isVideo,
    shouldUseCommentsPage
  }) =>
    new ArticleEntity({
      articleId,
      config,
      id,
      img,
      tag,
      numComments,
      commentsDisabled,
      description,
      url,
      title,
      isVideo,
      shouldUseCommentsPage
    })

  static articleDetailEntity = ({
    allowComments,
    author,
    body,
    category,
    customContentConfig,
    date,
    description,
    id,
    images,
    link,
    prosAndCons,
    publicationDate,
    relatedContent,
    seoMetaInformation,
    tagclouds,
    tag,
    title,
    totalNumberOfComments,
    updateDate,
    valoration,
    vehicles,
    video
  }) =>
    new ArticleDetailEntity({
      allowComments,
      author,
      body,
      category,
      customContentConfig,
      date,
      description,
      id,
      images,
      link,
      prosAndCons,
      publicationDate,
      relatedContent,
      seoMetaInformation,
      tagclouds,
      tag,
      title,
      totalNumberOfComments,
      updateDate,
      valoration,
      vehicles,
      video
    })

  static authorEntity = ({label, image, imageSize, slug}) => new AuthorEntity({label, image, imageSize, slug})
}
